/**
 * Code by Mathieu VANBESELAERE for ->
 * @copyright Copyright (c) Agence ink
 */

//// Module summary ////
// => This module contains the JS required by the services page, and its gsap animations

/////////////// GSAP animation modules (Uncomment required gsap library!) /////////////////
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger"; gsap.registerPlugin(ScrollTrigger);
// import ScrollSmoother from "gsap/ScrollSmoother"; gsap.registerPlugin(ScrollSmoother);
// import ScrollToPlugin from "gsap/ScrollToPlugin"; gsap.registerPlugin(ScrollToPlugin);
// import DrawSVGPlugin from "gsap/DrawSVGPlugin"; gsap.registerPlugin(DrawSVGPlugin);
import MorphSVG from "gsap/MorphSVGPlugin"; gsap.registerPlugin(MorphSVG);
// import SplitText from "gsap/SplitText"; gsap.registerPlugin(SplitText);
///////////////////////////////////////////////////////////////////////////////////////////

export const services = () => {
    const vh = window.innerHeight / 100;
  
    // [ANIMATION] SVG-MORPH
    // Changes the svgs to their assigned content. Rolls back to text when scroll is up.
    let morphContainer = document.querySelector(".cercle-wrapper");

    if (morphContainer) {
        // Variables
        let methodoItems = document.querySelectorAll(".metho-p-wrapper");
        let defaultTitle = document.querySelector('[data-gsap="morph-default"]');
        let duration = .4;
        let ease = "power4.out";
        // Assign trigger on svg's wrapper center
        let trigger = morphContainer.offsetHeight / 2 + 15 * vh + "px"; // 15 being the current assigned sitcky-top value!

        // This function is called when a trigger is reached.
        // Will check the given value to morph the SVGs
        let morph = (value) => {
            // If the element is an numbered entry, show their linked SVG (and hide the default title)
            if (value > 0 && value <= methodoItems.length) {
                gsap.to(defaultTitle, { autoAlpha: 0 });
                gsap.to('#o1', { morphSVG: '#o' + value, duration: duration, ease: ease, autoAlpha: 1 });
                gsap.to('#b1', { morphSVG: '#b' + value, duration: duration, ease: ease, autoAlpha: 1 });
            } else {
                // Else, just show the default title
                gsap.to('#o1', { autoAlpha: 0, duration: duration, ease: ease });
                gsap.to('#b1', { autoAlpha: 0, duration: duration, ease: ease });
                gsap.to(defaultTitle, { autoAlpha: 1 });
            }
        };

        // Create a ScrollTrigger for every items. They will pass a value to the morph function
        let i = 0;
        for (let current of methodoItems) {
            // Give them a number to call the function with
            current.setAttribute('data-item', i);
            i++;
            // Create the ScrollTrigger that will send values to the above functions
            ScrollTrigger.create({
                trigger: current,
                onEnter: () => morph(current.getAttribute('data-item')),
                onEnterBack: () => morph(current.getAttribute('data-item')),
                start: "top " + trigger,
                end: "bottom " + trigger,
                markers: false
            });
        }

        // [ANIMATION] SERVICES MARQUEES
        // Make the marquees appear from left to right, following their path
        let marqueesServices = document.querySelectorAll(".service-marquee-small");
        if (marqueesServices.length) {
            for (let currentMarquee of marqueesServices) {
                let marqueeContent = currentMarquee.querySelectorAll(".marquee-content");

                let TL_MARQUEES_SERVICES = gsap.timeline({
                    defaults: {
                        duration: 1
                    },
                    scrollTrigger: {
                        trigger: currentMarquee,
                        start: "top 85%",
                        markers: false
                    }
                });

                // A) Set to initial position
                gsap.set(currentMarquee, { x: "-100%" });
                gsap.set(marqueeContent, { autoAlpha: 0 });

                // B) Timeline
                TL_MARQUEES_SERVICES
                    .to(currentMarquee, { x: 0 })
                    .to(marqueeContent, {
                        autoAlpha: 1
                    });
            }
        }
        ///
    }
    return;
};
